
































































import _ from 'lodash';

import { editFactory } from '@/main/pages';
import dayJs from 'dayjs';
import { apiProvider } from '@/modules/kartoteka/vozidlo/api';

import { ScreenSize } from '@/main/components/constants';

import { NAME, VEHICLE_INSURANCE_DETAILS } from '../constants';
import { store } from '../store/edit';

export default editFactory(NAME, store).extend({
	name: 'InsuranceModal',
	provide(): {} {
		return { pageMode: this.pageMode };
	},
	data() {
		return {
			policyErrorMessage: '' as string | null,
			windowWidth: window.innerWidth,
			screenSize: ScreenSize.TABLET,
		};
	},
	computed: {
		getWidth() :string {
			return this.windowWidth <= this.screenSize ? ScreenSize.DIALOG_TABLET_WIDTH : ScreenSize.DIALOG_DEFAULT_WIDTH;
		},
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	},
	methods: {
		async loadData() {
			if (this.validationRules) {
				(this.validationRules as { PolicyType: { required: boolean } }).PolicyType.required = true;
				(this.validationRules as { PolicyVendor: { required: boolean } }).PolicyVendor.required = true;
				(this.validationRules as { PolicyPrice: { required: boolean } }).PolicyPrice.required = true;
				(this.validationRules as { PolicyStartDate: { required: boolean } }).PolicyStartDate.required = true;
				(this.validationRules as { PolicyEndDate: { required: boolean } }).PolicyEndDate.required = true;
			}
		},
		async policyDocuementChange(file: Record<string, any>) {
			this.fileList = [file];
		},
		handleRemove(fileList: []) {
			this.fileList = fileList;
		},
		async addInsurancePolicy() {
			this.startLoading();
			this.showPolicyDialog = false;
			let date = null;
			if (this.insurancePolicyDetails.PolicyStartDate === null) date = dayJs(new Date());
			else date = dayJs(this.insurancePolicyDetails.PolicyStartDate.toString());
			const { data: isValidInsurancePolicyReps } = await apiProvider.isValidPolicy(this.insurancePolicyDetails.VIN!, date.toString(), this.insurancePolicyDetails.Id);
			if (isValidInsurancePolicyReps) {
				const [policyFile] = this.fileList;
				if (!this.policyUpdateMode) {
					const { data: updateInsurancePolicyReps } = await apiProvider.insertInsurancePolicy(this.insurancePolicyDetails);
					if (updateInsurancePolicyReps) {
						if (!_.isNil(policyFile)) {
							apiProvider.savePolicyDocument(policyFile, updateInsurancePolicyReps);
						}
						this.fileList = [];
					}
				} else {
					const { data: updateInsurancePolicyReps } = await apiProvider.updateInsurancePolicy(this.insurancePolicyDetails);
					if (updateInsurancePolicyReps) {
						if (!_.isNil(policyFile)) {
							apiProvider.savePolicyDocument(policyFile, updateInsurancePolicyReps);
						}
						this.fileList = [];
					}
				}
				await this.refreshTable(VEHICLE_INSURANCE_DETAILS);
			} else {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('startPolicyMustGreater') });
				this.showPolicyDialog = true;
			}
			this.endLoading();
		},
	},
});
